<script>
    import {replace} from "svelte-spa-router";
import { onMount } from "svelte";
import {logueo} from "../store";
    export let params;
    let cliente = {nombre:"",documento:"",celular:"",fecha:""};
    let historial = [];
    let botones = [
		{nombre:"Volver",icon:"ri-arrow-left-line",href:"#/clientes"},
	]
    
    import {docs} from "../store";
    onMount(()=>{
        cliente = $docs.find((el)=>el._id == params.id);
        historial = $docs.filter((el)=> el._id.includes("registro:") && el.idCliente == params.id);
        if (!$logueo){
			replace('/');
		}
    })
    function verFecha(fecha){
        let f = new Date(fecha);
        return `${f.getDate() + 1}/${f.getMonth()+1}/${f.getFullYear()}`;
    }
</script>
<div class="p-4 w-screen max-w-full h-full min-h-screen  flex flex-col items-center">
    <div class="w-full sm:w-3/4 flex items-center justify-between">
		{#each botones as b}
			<a href={b.href} class="w-1/3 m-2 text-xs md:text-md text-white p-2 bg-red-500 cursor-pointer flex items-center justify-center rounded shadow ">
				<i class={b.icon} />
				{b.nombre}
		</a>
		{/each}
	</div>
    {#if cliente}
    <div class="w-full m-2 p-2 bg-white rounded shadow flex flex-col items-center justify-center">
        <p class="w-full text-xs"><span class="font-bold">Nombre: </span>{cliente.nombre}</p>
        <p class="w-full text-xs"><span class="font-bold">Documento: </span>{cliente.documento}</p>
        <p class="w-full text-xs"><span class="font-bold">Telefono: </span>{cliente.celular}</p>
        <p class="w-full text-xs"><span class="font-bold">Cumpleaños: </span>{verFecha(cliente.cumple)}</p>
    </div>
    <div class="w-full m-2 p-2 bg-white rounded shadow flex flex-col items-center justify-center">
        <p class="w-full flex items-center justify-center font-bold">Historial</p>
        {#each historial as historia}
            <div>{verFecha(historia.fecha)} - {historia.detalle} - ${historia.monto}</div>
        {/each}
    </div>
    <div class="w-full m-2 p-2 bg-white rounded shadow flex flex-col items-center justify-center">
        <p class="w-full flex items-center justify-center font-bold">Documentos</p>
        {#if cliente.documentos}
            <div class="flex flex-col items-center justify-start">
                <p class="text-xs font-bold">{cliente.documentos[0].cuerpo[0].nombre}</p>
                {#each cliente.documentos[0].cuerpo[0].texto as t}
                    <p class="text-xs">{t}</p>
                {/each}
            </div>
            <div class="flex flex-col items-center justify-start">
                <p class="text-xs font-bold">{cliente.documentos[0].cuerpo[1].nombre}</p>
                {#each cliente.documentos[0].cuerpo[1].texto as t}
                    <p class="text-xs">{t}</p>
                {/each}
            </div>
            <div class="flex flex-col items-center justify-start text-xs">

                <div class="font-bold text-xs w-full">Datos:</div>
			<div class="w-full flex items-center justify-between text-sm">
				<p class="w-full text-xs">
					<span class="font-bold">Nombre:</span> {cliente.nombre}
					<span class="font-bold">Documento:</span> {cliente.documento}
				</p>
			</div>
			<div class="w-full flex items-center justify-start text-xs">
				<span class="font-bold">Fecha de Nacimiento:</span> {verFecha(cliente.cumple)}
			</div>
			{#if cliente.nombreFamiliar}
			<div class="font-bold text-sm w-full">Acompañante Mayor:</div>
			<div class="flex items-center justify-between text-sm">
				<p class="w-full text-xs">
					<span class="font-bold">Nombre:</span> {cliente.nombreFamiliar}
					<span class="font-bold">Documento:</span> {cliente.documentoFamiliar}
					<span class="font-bold">Vínculo:</span> {cliente.vinculo}
				</p>
            </div>
            {/if}

                <img src={cliente.documentos[0].firma} alt="firma" />
            </div>
        {/if}
    </div>
    {/if}
</div>